import React from 'react'
import "../CSS/ScanToBimProjects.css"
import video5 from "../videos/POINT CLOUD SURVEY OF AN EMPTY LAND AND ITS ROAD NETWORK.mp4"
import video6 from "../videos/3D SCAN OF AN ESTATE, POINT CLOUD WALK THROUGH.mp4"
import video7 from "../videos/Point Cloud Of A Tank Farm, With 3d Scanner.mp4"

const ScanToBimProjects = () => {
  return (
    <div className='ScanToBimProjects'>
      <div className='ScanToBimProject' style={{width:"100%",backgroundColor:"gray"}}>
                    <h2> Scan-To-Bim Projects: </h2>
 

<span>This is a technology employed during the 
acquisition of AS-BUILT geometric data of any existing facility, can be used for 
engineering analysis such as: Actual Mass Haul of materials on Site, Actual cut and 
fill, For Structural Investigation Of Deflection On Structures. </span>

<br/>
<span style={{color:"rgb(201, 201, 255)",textDecoration:"underline"}}><strong>Softwares and hardwares used to actualize the objectives:</strong></span>
<span><strong>Hardware:</strong> Drone Dji Phantom, 3d Leica Scanners.iPhones12 and above</span>
<span><strong>Software:</strong> Autodesk Recap Pro, Agisoft, Drone Deploy, Qgis, Cyclone. </span>
<br/>
<span style={{textAlign:"center",textDecoration:"underline",fontWeight:"bold",color:"rgb(201, 201, 255)"}}>WALK THROUGH OF SCAN TO BIM PROJECTS</span>
<br/>
<div className='WalkThroughWrap'>
    <div className='WalkThrough'>
        <video controls loop className='WalkThroughMedia'>
            <source src={video5} type='video/mp4'/>
        </video>
        <p>Alpha</p>
    </div>
    <div className='WalkThrough'>
        <video controls loop className='WalkThroughMedia'>
            <source src={video7} type='video/mp4'/>
        </video>
        <p>Beta</p>
    </div>
    <div className='WalkThrough' >
        <video controls loop className='WalkThroughMedia'>
            <source src={video6} type='video/mp4'/>
        </video>
        <p>Gamma</p>
    </div>

</div>
                </div>
      </div>
  )
}

export default ScanToBimProjects
